import { DARK, DARK_COLOR } from "../../constants/configuration";
export const Styles = {
  tabStyle: {
    display: "flex",
    height: "36px",
    padding: " 4px 16px",
    alignItems: "center",
    gap: "8px",
    textDecoration: "none",
  },
  container: {
    marginTop: "26px",
    display: "flex",
    width: "210px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "16px",
  },
  mobileContainer: {
    flexDirection: "row",
    display: "flex",
    padding: "12px 16px",
    alignItems: "center",
    gap: "16px",
    background: (theme) =>
      theme.palette.mode === DARK ? DARK_COLOR : "rgba(255, 255, 255, 0.50)",
  },
};
